/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SettlementAgreementComponent} from './settlement-agreement.component';
import {SettlementAgreementTableComponent} from './settlement-agreement-table/settlement-agreement-table.component';
import {TableModule} from '../../shared/table/table.module';
import {SettlementDetailTitleModule} from '../settlemente-detail-title/settlement-detail-title.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {SettlementRejectMotivationModule} from './settlement-reject-motivation/settlement-reject-motivation.module';
import {SettlementAcceptCommentModule} from './settlement-accept-comment/settlement-accept-comment.module';
import {FlyingMenuModule} from '../../shared/flying-menu/flying-menu.module';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        TableModule,
        SettlementDetailTitleModule,
        PipesModule,
        SettlementRejectMotivationModule,
        SettlementAcceptCommentModule,
        FlyingMenuModule,
        TooltipModule
    ],
    declarations: [SettlementAgreementComponent, SettlementAgreementTableComponent],
    exports: [SettlementAgreementComponent]
})
export class SettlementAgreementModule {
}
